// Third-party libraries
import { useEffect, useState } from 'react';
import { driver, DriveStep } from 'driver.js';

// Hooks
import useCookies from '../useCookies';

// Locales
import I18n from '../../../i18n';

export default function useTutorial(name: string, steps?: DriveStep[]) {
  const { setCookie, getCookie } = useCookies();

  const [isDone, setIsDone] = useState(() => {
    return getCookie(name) === 'done';
  });

  const driverObj = driver({
    showProgress: true,
    steps,
    onDestroyed: () => {
      setCookie(name, 'done', 365);
      setIsDone(true);
    },
    prevBtnText: I18n.t('buttons.actions.previous'),
    nextBtnText: I18n.t('buttons.actions.next'),
    doneBtnText: I18n.t('buttons.actions.done')
  });

  useEffect(() => {
    const tutorialCookie = getCookie(name);
    setIsDone(tutorialCookie === 'done');
  }, [getCookie, name]);

  const setStepsTutorial = (steps: DriveStep[]) => {
    driverObj.setSteps(steps);
  };

  const startTutorial = () => {
    if(!driverObj.isActive()){
      driverObj.drive();
    }
  };

  return { isDone, setStepsTutorial, startTutorial };
}
